import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la sensación",
    opening: localizedGenderNode(
      [
      "Hoy noto la sensación de fracaso.",
      "Solo notarla.",
      "Estoy aquí."
    ],
      [
      "Hoy noto la sensación de fracaso.",
      "Solo notarla.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo sube más esta sensación?",
      "¿Qué me digo entonces?",
      "¿Dónde se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo sube más esta sensación?",
      "¿Qué me digo entonces?",
      "¿Dónde se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una sensación es una sensación, no una identidad."
    ],
      [
      "Una sensación es una sensación, no una identidad."
    ]
    ),
    action: localizedGenderNode(
      "una respiración + \"Estoy aquí\".",
      "una respiración + \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El momento que activa",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que se enciende la sensación.",
      "Solo verla.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto el momento en que se enciende la sensación.",
      "Solo verla.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasó justo antes de que empezara?",
      "¿Qué frase sobre mí salta de inmediato?",
      "¿Qué siento entonces?"
    ],
      [
      "¿Qué pasó justo antes de que empezara?",
      "¿Qué frase sobre mí salta de inmediato?",
      "¿Qué siento entonces?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un pequeño espacio."
    ],
      [
      "En el primer momento tengo un pequeño espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cuando sube la sensación.",
      "una respiración cuando sube la sensación."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Mi cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo cuando se siente el fracaso.",
      "No para arreglarlo.",
      "Estoy aquí."
    ],
      [
      "Hoy escucho mi cuerpo cuando se siente el fracaso.",
      "No para arreglarlo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde sostiene mi cuerpo la sensación?",
      "¿Qué necesita mi cuerpo en ese momento?",
      "¿Qué podría suavizarse un poco?"
    ],
      [
      "¿Dónde sostiene mi cuerpo la sensación?",
      "¿Qué necesita mi cuerpo en ese momento?",
      "¿Qué podría suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta cuidarme."
    ],
      [
      "Mi cuerpo intenta cuidarme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiración.",
      "una mano en el pecho y una respiración."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Hecho vs. historia",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de la historia sobre mí.",
      "Sin pelearla.",
      "Estoy aquí."
    ],
      [
      "Hoy separo hecho de la historia sobre mí.",
      "Sin pelearla.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia salta sobre mí?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ],
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia salta sobre mí?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es interpretación\".",
      "una frase interna - \"Esto es interpretación\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El costo",
    opening: localizedGenderNode(
      [
      "Hoy veo el costo de la sensación de fracaso.",
      "Sin castigo.",
      "Estoy aquí."
    ],
      [
      "Hoy veo el costo de la sensación de fracaso.",
      "Sin castigo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me quita esto?",
      "¿Dónde me hago más pequeño/a?",
      "¿Qué me gustaría devolverme?"
    ],
      [
      "¿Qué me quita esto?",
      "¿Dónde me hago más pequeño/a?",
      "¿Qué me gustaría devolverme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el costo es un paso de compasión."
    ],
      [
      "Ver el costo es un paso de compasión."
    ]
    ),
    action: localizedGenderNode(
      "una palabra sobre lo que devuelvo.",
      "una palabra sobre lo que devuelvo."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Disparadores",
    opening: localizedGenderNode(
      [
      "Hoy noto qué activa la sensación de fracaso.",
      "Solo notarlo.",
      "Estoy aquí."
    ],
      [
      "Hoy noto qué activa la sensación de fracaso.",
      "Solo notarlo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se enciende más?",
      "¿Qué situación o persona me activa?",
      "¿Qué necesito en ese momento?"
    ],
      [
      "¿Cuándo se enciende más?",
      "¿Qué situación o persona me activa?",
      "¿Qué necesito en ese momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando noto un disparador, tengo un pequeño espacio."
    ],
      [
      "Cuando noto un disparador, tengo un pequeño espacio."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho cuando sube.",
      "una mano en el pecho cuando sube."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un límite suave",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite suave a la voz del fracaso.",
      "En silencio.",
      "Estoy aquí."
    ],
      [
      "Hoy pongo un límite suave a la voz del fracaso.",
      "En silencio.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué frases son demasiado para mí?",
      "¿Qué límite quiero poner?",
      "¿Cómo me lo digo?"
    ],
      [
      "¿Qué frases son demasiado para mí?",
      "¿Qué límite quiero poner?",
      "¿Cómo me lo digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite interno es protección, no guerra."
    ],
      [
      "Un límite interno es protección, no guerra."
    ]
    ),
    action: localizedGenderNode(
      "decir \"No me hablo así\".",
      "decir \"No me hablo así\"."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña compasión",
    opening: localizedGenderNode(
      [
      "Hoy intento hablarme con suavidad.",
      "Aunque sea nuevo.",
      "Estoy aquí."
    ],
      [
      "Hoy intento hablarme con suavidad.",
      "Aunque sea nuevo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué cambia en mí cuando la escucho?"
    ],
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué cambia en mí cuando la escucho?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra suave es suficiente para empezar."
    ],
      [
      "Una palabra suave es suficiente para empezar."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Ver lo bueno",
    opening: localizedGenderNode(
      [
      "Hoy doy espacio a lo bueno pequeño en mí.",
      "Sin exagerar.",
      "Estoy aquí."
    ],
      [
      "Hoy doy espacio a lo bueno pequeño en mí.",
      "Sin exagerar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Escucho mi respiración.",
      "Una respiración."
    ],
      [
      "Escucho mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cosa buena hay en mí hoy?",
      "¿Dónde se siente en el cuerpo?",
      "¿Qué me llevo de eso?"
    ],
      [
      "¿Qué cosa buena hay en mí hoy?",
      "¿Dónde se siente en el cuerpo?",
      "¿Qué me llevo de eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño bien es suficiente para empezar."
    ],
      [
      "Un pequeño bien es suficiente para empezar."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra de bien.",
      "escribir una palabra de bien."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición para mí",
    opening: localizedGenderNode(
      [
      "Hoy me doy una petición clara.",
      "No una exigencia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy me doy una petición clara.",
      "No una exigencia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiración."
    ],
      [
      "Respiro lento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ],
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede suavizar el día."
    ],
      [
      "Una petición puede suavizar el día."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase corta.",
      "escribir la petición en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ],
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar hoy?",
      "¿Cuándo es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ],
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar hoy?",
      "¿Cuándo es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño cambio es un movimiento suave."
    ],
      [
      "Un pequeño cambio es un movimiento suave."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para probarlo.",
      "elegir un momento para probarlo."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Ser humano/a",
    opening: localizedGenderNode(
      [
      "Hoy doy espacio a ser humano/a.",
      "Sin descartarlo.",
      "Estoy aquí."
    ],
      [
      "Hoy doy espacio a ser humano/a.",
      "Sin descartarlo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasaría si me permito ser humano/a?",
      "¿Qué liberaría en mí?",
      "¿Qué suavidad puedo darme?"
    ],
      [
      "¿Qué pasaría si me permito ser humano/a?",
      "¿Qué liberaría en mí?",
      "¿Qué suavidad puedo darme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ser humano/a no es un fracaso."
    ],
      [
      "Ser humano/a no es un fracaso."
    ]
    ),
    action: localizedGenderNode(
      "una frase de permiso para mí.",
      "una frase de permiso para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una pequeña práctica",
    opening: localizedGenderNode(
      [
      "Hoy elijo una práctica pequeña que suaviza la sensación.",
      "Simple.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo una práctica pequeña que suaviza la sensación.",
      "Simple.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ],
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué práctica pequeña podría ayudarme hoy?",
      "¿Cuándo en el día la hago?",
      "¿Qué me recordará suavemente?"
    ],
      [
      "¿Qué práctica pequeña podría ayudarme hoy?",
      "¿Cuándo en el día la hago?",
      "¿Qué me recordará suavemente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una práctica pequeña crea un cambio suave."
    ],
      [
      "Una práctica pequeña crea un cambio suave."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para la práctica.",
      "elegir un momento para la práctica."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ],
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre la sensación de fracaso?",
      "¿Cuál es la señal temprana de que vuelve?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ],
      [
      "¿Qué aprendí sobre la sensación de fracaso?",
      "¿Cuál es la señal temprana de que vuelve?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo equivocarme y aun así quedarme conmigo."
    ],
      [
      "Puedo equivocarme y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración antes de responder.",
      "una respiración antes de responder."
    ),
  },
].map(buildNormalizedDay);

export const chronicFeelingOfFailureBlueprintEs = buildNormalizedPilotBlueprint({
  id: "chronic_feeling_of_failure_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "chronic_feeling_of_failure",
  category: "self_worth",
  journeyName: {
    he: "תחושת כישלון כרונית",
    en: "Chronic feeling of failure",
    es: "Sensación crónica de fracaso",
  },
  days,
});

export default chronicFeelingOfFailureBlueprintEs;
